import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  Box,
  Chip
} from '@mui/material';
import { Security, CheckCircle } from '@mui/icons-material';

const SecurityNotification = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Vérifier si c'est la première visite depuis la mise à jour sécurisée
    const hasSeenSecurityUpdate = localStorage.getItem('hasSeenSecurityUpdate');
    
    if (!hasSeenSecurityUpdate) {
      // Attendre 2 secondes après le chargement pour montrer la notification
      const timer = setTimeout(() => {
        setOpen(true);
      }, 2000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem('hasSeenSecurityUpdate', 'true');
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 }
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        <Security sx={{ fontSize: 40, color: 'success.main', mb: 1 }} />
        <Typography variant="h5" component="div">
          Mise à Jour Sécurité
        </Typography>
      </DialogTitle>
      
      <DialogContent>
        <Alert severity="success" sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            🔒 Vos données sont maintenant mieux protégées !
          </Typography>
        </Alert>

        <Box sx={{ mb: 3 }}>
          <Typography variant="body1" paragraph>
            Nous avons récemment mis à jour notre système de sécurité :
          </Typography>
          
          <Box sx={{ pl: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <CheckCircle sx={{ color: 'success.main', mr: 2 }} />
              <Typography variant="body2">
                <strong>Accès restreint :</strong> Les pages d'analyse sont maintenant protégées par authentification admin
              </Typography>
            </Box>
            
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <CheckCircle sx={{ color: 'success.main', mr: 2 }} />
              <Typography variant="body2">
                <strong>Données sensibles :</strong> Les métriques business ne sont plus publiquement accessibles
              </Typography>
            </Box>
            
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <CheckCircle sx={{ color: 'success.main', mr: 2 }} />
              <Typography variant="body2">
                <strong>Navigation sécurisée :</strong> Redirection automatique vers la connexion admin si nécessaire
              </Typography>
            </Box>
          </Box>
        </Box>

        <Alert severity="info">
          <Typography variant="body2">
            Si vous êtes administrateur, un accès discret est disponible dans le footer de la page.
          </Typography>
        </Alert>
      </DialogContent>
      
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button 
          onClick={handleClose}
          variant="contained"
          size="large"
          sx={{ 
            px: 4,
            background: 'linear-gradient(45deg, #4caf50 30%, #66bb6a 90%)'
          }}
        >
          J'ai compris
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SecurityNotification;